module.exports = __webpack_public_path__ + "img/input-arrow.9f83c0ba.svg";